import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=d0a3f7b4&scoped=true"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&id=d0a3f7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a3f7b4",
  null
  
)

export default component.exports